var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpeedGreen = function SvgSpeedGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#speed-green_svg__a)",
    d: "M68.699 9.328a.004.004 0 0 0-.003-.006L31.814 7.027a1.75 1.75 0 0 0-1.75 1.129l-1.737 4.517a1.751 1.751 0 0 0 .397 1.861l4.715 4.715a1.76 1.76 0 0 1 0 2.482L15.893 39.277a1.76 1.76 0 0 0 0 2.482l22.013 22.013a1.76 1.76 0 0 0 2.482 0l17.546-17.546a1.76 1.76 0 0 1 2.482 0l4.194 4.194c.496.497 1.24.646 1.899.385l4.467-1.787a1.725 1.725 0 0 0 1.092-1.712l-1.725-36.32c-.05-.891-.74-1.61-1.642-1.65-.003-.001-.005-.005-.002-.008ZM7.058 50.495 29.17 72.607a1.76 1.76 0 0 0 2.482 0l3.785-3.784a1.76 1.76 0 0 0 0-2.482L13.324 44.228a1.76 1.76 0 0 0-2.482 0l-3.784 3.785a1.76 1.76 0 0 0 0 2.482Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m24.5 46-13 13M48.5 42l-13 13M34 46.5l-21 21"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "speed-green_svg__a",
    x1: 65.54,
    x2: 23.855,
    y1: 55.66,
    y2: 14.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CA72",
    stopOpacity: 0.2
  })))));
};
export default SvgSpeedGreen;